import React, { useEffect } from 'react'
import Navbars from '../../../Components/Navbar'
import { getAuth, signOut } from "firebase/auth";
import firebaseConfig from '../../../Utilities/Firebase'
import { initializeApp } from 'firebase/app';

function LandingPage() {
const FirebaseApp = initializeApp(firebaseConfig);
  useEffect(() => {
    signOutCurrentUser();
      // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  function signOutCurrentUser() {
    const auth = getAuth(FirebaseApp);
    signOut(auth).then(() => {
      console.log("logout successful");
    }).catch((error) => {
      console.log(error);
    });
  }
  return (
    <div>
      <Navbars type={'0'} />
      <div>
        <h1
          style={{
            color: '#636B65',
            marginTop: '7%',
            textAlign: 'center',
            fontSize: '84px',
            fontWeight: '100',
            fontFamily: 'sans-serif',
          }}
        >
          DJSCE || DJCSI
        </h1>
        <center>
          <a
            style={{
              color: '#636B65',
              fontSize: '50px',
              fontWeight: '50',
              marginLeft: '5%',
              marginTop: '10%',
            }}
            href="https://djcsi.co.in/"
          >
            DJCSI
          </a>
        </center>
      </div>
    </div>
  )
}
export default LandingPage
